// extracted by mini-css-extract-plugin
export default {"IncludeTargetIcon":"IncludeExcludeTarget-module__IncludeTargetIcon--_YyjI","ExcludeTargetIcon":"IncludeExcludeTarget-module__ExcludeTargetIcon--rnwZ4"};